import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Envelope, MapPin } from "@phosphor-icons/react";
import { COMPANY, SERVICES, NAV_LINKS } from "../data/site";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-line bg-ink" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-6 pb-12 pt-24 md:px-12 md:pt-32">
      <div className="grid gap-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src="/assets/logo-white.png" alt="Prott Bauunternehmung Logo" className="h-16 w-auto" />
          <p className="mt-8 max-w-xs text-sm leading-relaxed text-ash">
            Familiengeführtes Bauunternehmen mit 30-jähriger Expertise in Rohbau, Umbau, Sanierung und Garten- & Landschaftsbau — aus Offenbach am Main, für die Region Frankfurt und darüber hinaus.
          </p>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-ember">Leistungen</h3>
          <ul className="mt-8 space-y-4">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to="/leistungen" data-testid={`footer-service-${s.slug}`} className="group flex items-center gap-2 text-sm text-ash transition-colors duration-300 hover:text-bone">
                  <span className="font-mono text-[10px] text-line">{s.nr}</span>
                  {s.title}
                  <ArrowUpRight size={12} className="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-ember">Navigation</h3>
          <ul className="mt-8 space-y-4">
            {[...NAV_LINKS, { to: "/kontakt", label: "Kontakt" }].map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase().replace(/ü/g, "ue").replace(/\s/g, "-")}`} className="text-sm text-ash transition-colors duration-300 hover:text-bone">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-ember">Kontakt</h3>
          <ul className="mt-8 space-y-5 text-sm text-ash">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-ember" />
              <span data-testid="footer-address">{COMPANY.name}<br />Inh. {COMPANY.owner}<br />{COMPANY.street}<br />{COMPANY.city}</span>
            </li>
            <li>
              <a href={COMPANY.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 transition-colors duration-300 hover:text-bone">
                <Phone size={16} className="shrink-0 text-ember" /> {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={COMPANY.emailHref} data-testid="footer-email" className="flex items-center gap-3 break-all transition-colors duration-300 hover:text-bone">
                <Envelope size={16} className="shrink-0 text-ember" /> {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-24 flex flex-col gap-6 border-t border-line pt-10 md:flex-row md:items-center md:justify-between">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash">
          © {new Date().getFullYear()} {COMPANY.name} — Alle Rechte vorbehalten
        </p>
        <div className="flex gap-8">
          <Link to="/impressum" data-testid="footer-impressum" className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-ember">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz" className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-ember">Datenschutz</Link>
        </div>
      </div>
    </div>

    <div aria-hidden="true" className="pointer-events-none select-none overflow-hidden">
      <p className="text-outline -mb-6 whitespace-nowrap text-center font-display text-[22vw] font-black leading-none tracking-tighter opacity-60 md:-mb-12">
        PROTT
      </p>
    </div>
  </footer>
);
